var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5546_2868",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5546_2868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 17C5.44772 17 5 16.5523 5 16V11C5 10.4477 5.44772 10 6 10C6.55228 10 7 10.4477 7 11V16C7 16.5523 6.55228 17 6 17ZM12 17C11.4477 17 11 16.5523 11 16V11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17ZM3 21C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H3ZM18 17C17.4477 17 17 16.5523 17 16V11C17 10.4477 17.4477 10 18 10C18.5523 10 19 10.4477 19 11V16C19 16.5523 18.5523 17 18 17ZM3 8C2.44772 8 2 7.55228 2 7V6.61803C2 6.23926 2.214 5.893 2.55279 5.72361L11.5528 1.22361C11.8343 1.08284 12.1657 1.08284 12.4472 1.22361L21.4472 5.72361C21.786 5.893 22 6.23926 22 6.61803V7C22 7.55228 21.5523 8 21 8H3ZM10.2765 4.10396C9.32927 4.57333 9.66334 6 10.7205 6H13.2795C14.3367 6 14.6707 4.57333 13.7235 4.10396L12.444 3.46999C12.1642 3.33137 11.8358 3.33137 11.556 3.46999L10.2765 4.10396Z",
    strokeWidth: 2,
    fill: "#2B1E59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account_balance.7059d07793a742cce6ae03b22cb8b672.svg";
export { ForwardRef as ReactComponent };